'use strict';

import angular from 'angular';
import ActivateWebaccessController from './activate-webaccess.controller';

export default angular.module('conduu.activateWebaccess', [])
  .controller('ActivateWebaccessController', ActivateWebaccessController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/activate-webaccess/index.js